import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './BulkActionModalView.scss';

class BulkActionModal extends Component {
  render() {
    return (
      <Modal
        centered
        show={this.props.showModal}
        onHide={this.props.onHide}
        className={`generate-modal ${this.props.modalClassName}`}
      >
        <Modal.Header>
          <div className={`header-title`}>{this.props.modalTitle}</div>
          <div className={`header-content`}>{this.props.modalGeneralContent}</div>
          {this.props.modalListTitle}
        </Modal.Header>
        <Modal.Body>
          <div className="list-container">
            {this.props.modalDetailContent}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-content">
            {this.props.modalFooterContent}
          </div>
          <div className={`footer-action-btn ${!this.props.showCancel ? 'single-button' : ''}`}>
            {this.props.showCancel && (
              <Button
                className="btn-back-button-common delete-campaign-pop-content-button delete-campaign-pop-content-cancel"
                onClick={this.props.onHide}
                disabled={this.props.isLoading}
              >
                Cancel
              </Button>
            )}
            <Button
              className="btn-further unsave-create-prompt-continue button-save-padding"
              onClick={async () => {  // Make this async
                if (this.props.action) {
                    await this.props.action();  // Await the action
                }
              }}
              disabled={this.props.isLoading}
            >
              {this.props.isLoading ? 'Processing...' : this.props.actionName}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BulkActionModal;
